import * as Yup from 'yup';

// W-0654 — Validações do form de Altera Código Departamento.
// Paridade Delphi UAlteraDepto.pas (Edit2 = novo código, Edit4 = observação).
// Mensagens LITERAIS Delphi (Q-05=C híbrido) — preservar verbatim.
// Inputs type="text" + inputMode="numeric" — validação string + regex (evita efeitos colaterais
// de type="number").
export const alterarCodigoDepartamentoSchema = Yup.object().shape({
  codigoGrupoEmpresa: Yup.number()
    .typeError('Selecione um GE.')
    .required('Selecione um GE.'),
  codigoDepartamentoAtual: Yup.number()
    .typeError('Deverá existir um código atual.')
    .required('Deverá existir um código atual.')
    .positive('Deverá existir um código atual.')
    .integer(),
  codigoDepartamentoNovo: Yup.string()
    .required('Deverá existir um código novo.')
    .matches(/^\d+$/, 'Novo código deve conter apenas números')
    .test('min1', 'Deverá existir um código novo.', (val) => {
      const n = val ? parseInt(val, 10) : 0;
      return n >= 1;
    })
    .test(
      'different-from-atual',
      'Código atual é igual a novo código.',
      function (value) {
        const atual = this.parent.codigoDepartamentoAtual;
        if (value == null || value === '' || atual == null || atual === '')
          return true;
        return Number(value) !== Number(atual);
      }
    ),
  observacao: Yup.string()
    .required('Obs não pode ser nula.')
    .max(255, 'Observação muito longa.'),
});
